/**
 * Created by zhaoy on 2022/11/18
 * Desc: 话费预存列表item
 */

import React, { Component } from 'react'

export default class PayableCostRecordItem extends Component {

  constructor () {
    super()

    this.state = {}
  }

  componentDidMount () {

  }

  componentWillUnmount () {

  }

  render () {
    const { rechargeBean } = this.props
    return (
      <div className='recharge-record-item-root'>
        <div style={{ flex: 2, padding: '0 4px' }}>充值{rechargeBean.payAmount}元
        </div>
        <div style={{ flex: 2, padding: '0 4px' }}>{rechargeBean.yearsMany}</div>
        <div style={{
          flex: 3,
          textAlign: 'right',
          padding: '0 4px',
          fontSize:'10px',
        }}>{rechargeBean.payDate}</div>
        {/*<div style={{
                  flex: 3,
                  textAlign: 'right',
                  padding: '0 4px',
                  fontSize:'10px',
                }}>截止日期：{rechargeBean.costDate}</div>*/}
      </div>
    )
  }
}
